export const meta = {
  id: 'O05', slug: 'associar-mentor-mentorado', title: 'Como associar Mentor e Mentorado',
  description: 'Defina quais mentorados um Mentor pode acompanhar dentro do Personagrama.',
  profile: 'owner', category: 'pessoas', type: 'task', status: 'published', order: 350,
  keywords: ['mentor', 'mentorado', 'associação', 'carteira', 'acesso'], previous: 'O04', next: 'O06',
  related: ['M01', 'O04'], updatedAt: '2026-08-17', appVersion: 'v1'
}

# Como associar Mentor e Mentorado

A associação é o vínculo que autoriza o Mentor a acompanhar uma pessoa específica.

<HelpImage pendingId="O06.1" alt="Tela de associação entre Mentor e Mentorado" />

<Steps>
  <Step title="Localize o Mentor">Acesse a gestão de pessoas e selecione o Mentor correto.</Step>
  <Step title="Defina o Mentorado">Selecione a pessoa que ficará sob acompanhamento.</Step>
  <Step title="Confirme a associação">Salve o vínculo conforme as opções disponíveis.</Step>
  <Step title="Revise a carteira">Confirme se o Mentor visualiza somente os mentorados esperados.</Step>
</Steps>

<Callout type="important">O papel de Mentor, sozinho, não concede acesso a todos os alunos. A autorização depende do vínculo configurado.</Callout>
